<div class="data-filter" style="padding: 0px 5px;">
    <label style="margin: 0px; font-weight: bold;">{{label}}</label>
    <input [type]="isNumber ? 'number': 'text'" class="form-control form-control-sm" [(ngModel)]="model" [placeholder]="placeholder" [disabled]="disabled" [min]="isNumber ? min : ''" [max]="isNumber ? max : ''" [step]="isNumber ? step : ''" (change)="change()">
</div>